<template>
  <div>
    <header-bar>アーティスト{{ isEdit ? '編集' : '登録' }}</header-bar>
    <div class="page-block">
      <artist-confirm
        v-if="showConfirmation"
        :item="item"
        :image="previewImage"
        :spotify-image="previewSpotifyImage"
        :is-edit="isEdit"
        :socials="socials"
        @return-clicked="onReturnClicked"
        @save-clicked="onSaveClicked">
      </artist-confirm>
      <div
        v-else
        class="single-column">
        <section class="single-column__section">
          <h2 class="single-column__heading">アーティスト{{ isEdit ? '編集' : '登録' }}</h2>
          <div class="single-column__inner">
            <div
              v-if="isNew"
              class="profile-edit__head-text">
              <span>アーティストを登録してください。</span>
              <br>あとで記入することも可能です。
            </div>
            <ul class="c-indent-list profile-edit__head-text">
              <li
                v-if="isBtoC"
                class="c-indent-list__node">
                アーティスト写真、プロフィールは配信ストアへ提供しておりません。
                原則narasuでの表示のみとなります。
              </li>
              <li class="c-indent-list__node">
                配信審査依頼後～配信期間中は、アーティスト名の変更を行っても、各配信ストアの情報は変更されません。
              </li>
              <li class="c-indent-list__node">
                各配信ストアの規定により表記が変更される場合があります。
                また、変更をお願いする場合があります。
              </li>
            </ul>
            <alert-view
              v-if="!realtimeValidation"
              :errors="errors" />

            <form
              :class="{ 'form--error': errors }">
              <div class="profile-info">
                <div class="form-wrap form-wrap--profile u-no-margin-top">
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        v-tooltip="spTooltipConfig(tooltipMessages.name_ja)"
                        class="control-label"
                        for="artist_name_domestic">アーティスト名
                        <span class="req">＊</span>
                      </label>
                      <i
                        v-tooltip="spTooltipConfig(tooltipMessages.name_ja)"
                        class="sp-tooltip-icon">
                      </i>
                    </div>
                    <div
                      class="form-item">
                      <input
                        id="artist_name_domestic"
                        v-model="item.name_ja"
                        v-tooltip="pcTooltipConfig(tooltipMessages.name_ja)"
                        :disabled="hasProducts"
                        class="form-control"
                        type="text"
                        @blur="onFieldChanged('name_ja')">
                      <p
                        v-if="errors.name_ja"
                        class="error-text">
                        {{ errors.name_ja[0] }}
                      </p>
                      <p
                        v-else-if="showWarningMsg"
                        class="error-text">
                        {{ warningMsg }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        v-tooltip="spTooltipConfig(tooltipMessages.name_kana)"
                        class="control-label"
                        for="artist_name_hk">アーティスト名（カナ表記）
                        <span class="req">＊</span>
                      </label>
                      <i
                        v-tooltip="spTooltipConfig(tooltipMessages.name_kana)"
                        class="sp-tooltip-icon">
                      </i>
                    </div>
                    <div class="form-item">
                      <input
                        id="artist_name_hk"
                        v-model="item.name_kana"
                        v-tooltip="pcTooltipConfig(tooltipMessages.name_kana)"
                        :disabled="hasProducts"
                        class="form-control"
                        type="text"
                        @blur="onFieldChanged('name_kana')">
                      <p
                        v-if="errors.name_kana"
                        class="error-text">
                        {{ errors.name_kana[0] }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        v-tooltip="spTooltipConfig(tooltipMessages.name_en)"
                        class="control-label"
                        for="artist_name_overseas">アーティスト名（アルファベット表記）
                        <span class="req">＊</span>
                      </label>
                      <i
                        v-tooltip="spTooltipConfig(tooltipMessages.name_en)"
                        class="sp-tooltip-icon">
                      </i>
                    </div>
                    <div class="form-item">
                      <input
                        id="artist_name_overseas"
                        v-model="item.name_en"
                        v-tooltip="pcTooltipConfig(tooltipMessages.name_en)"
                        :disabled="hasProducts"
                        class="form-control"
                        type="text"
                        @blur="onFieldChanged('name_en')">
                      <p
                        v-if="errors.name_en"
                        class="error-text">
                        {{ errors.name_en[0] }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="isBtoC"
                    class="form-group">
                    <div class="form-label">
                      <label class="control-label"> アーティストページ設定</label>
                    </div>
                    <div class="form-item">
                      <div class="form-item">
                        <div class="form-item-inline">
                          <div class="radio">
                            <label for="classification_cover">
                              <input
                                id="classification_cover"
                                v-model="item.is_narasu_displayed"
                                type="radio"
                                name="is_narasu_displayed"
                                :value="1">
                              <div class="option-input"></div> 表示
                            </label>
                          </div>
                          <div class="radio">
                            <label for="classification_arrange">
                              <input
                                id="classification_arrange"
                                v-model="item.is_narasu_displayed"
                                type="radio"
                                name="classification"
                                :value="0">
                              <div class="option-input"></div> 非表示
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        class="control-label"
                        for="profile_domestic">プロフィール
                      </label>
                    </div>
                    <div class="form-item">
                      <textarea
                        id="profile_domestic"
                        v-model="item.profile_ja"
                        class="c-textarea">
                            </textarea>
                      <p
                        v-if="errors.profile_ja"
                        class="error-text">
                        {{ errors.profile_ja[0] }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        for="url">オフィシャルサイト
                        <span>（URL）</span>
                      </label>
                    </div>
                    <div class="form-item">
                      <input
                        id="url"
                        v-model="item.url"
                        class="form-control form-control--w400"
                        type="text"
                        placeholder="https://narasu.jp/"
                        @blur="onFieldChanged('url')">
                      <p
                        v-if="errors.url"
                        class="error-text">
                        {{ errors.url[0] }}
                      </p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        for="blog">ブログ
                        <span>（URL）</span>
                      </label>
                    </div>
                    <div class="form-item">
                      <input
                        id="blog"
                        v-model="item.blog"
                        class="form-control form-control--w400"
                        type="text"
                        placeholder="https://narasu.jp/"
                        @blur="onFieldChanged('blog')">
                      <p
                        v-if="errors.blog"
                        class="error-text">
                        {{ errors.blog[0] }}
                      </p>
                    </div>
                  </div>
                  <div
                    v-for="(social,sns) in socials"
                    :key="social.type"
                    class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        :for="sns">{{ social.title }}
                        <span
                          v-if="social.note">
                          {{ social.note }}</span>
                      </label>
                    </div>
                    <div class="form-item">
                      <input
                        :id="sns"
                        v-model="item.socials[`${social.type}`]"
                        class="form-control form-control--w400"
                        type="text"
                        :placeholder="social.placeholder"
                        @blur="onFieldChanged(`socials.${social.type}`)">
                      <p
                        v-if="errors[`socials.${social.type}`]"
                        class="error-text">
                        {{ errors[`socials.${social.type}`][0] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <ul class="c-indent-list profile-edit__head-text">
                    <li class="c-indent-list__desc">
                      アーティスト写真を設定する場合は、下記の項目の設定もお願いいたします。
                    </li>
                  </ul>
                </div>

                <div class="profile-info">
                  <div class="form-wrap form-wrap--profile u-no-margin-top">
                    <div
                      slot="content"
                      class="content_block">
                      <div
                        class="form-group">
                        <div class="form-label">
                          <label
                            v-tooltip="spTooltipConfig(tooltipMessages.artistImage)"
                            class="control-label">アーティスト写真
                          </label>
                          <i
                            v-tooltip="spTooltipConfig(tooltipMessages.artistImage)"
                            class="sp-tooltip-icon">
                          </i>
                        </div>

                        <div
                          v-if="isBtoC || isPhotoChangeable"
                          class="form-item">
                          <img
                            v-if="previewImage"
                            style="max-width: 320px"
                            :src="previewImage">
                          <a
                            v-tooltip="pcTooltipConfig(tooltipMessages.artistImage)"
                            class="c-btn c-btn--download--narrow"
                            :class=" { 'image-upload-btn' : previewImage } "
                            href="#"
                            @click.prevent="onUploadClicked">
                            {{ previewImage ? '画像を変更する' : 'ファイルをアップロード' }}
                            <img
                              src="/img/common/icon-download_white.png"
                              alt="">
                          </a>
                          <p
                            v-if="isBtoC"
                            class="publish-date-description">
                            ※ narasuの
                            <router-link
                              :to="{ name : 'terms' }"
                              class="c-text-link"
                              target="_blank">
                              利用規約
                            </router-link>
                            に沿った画像をアップロードしてください
                          </p>
                          <p
                            v-if="isBtoB"
                            class="publish-date-description">
                            ※ アーティスト写真は必ず
                            <router-link
                              :to="{ name : 'faq-detail', params: {id: 161} }"
                              class="c-text-link">
                              登録規定
                            </router-link>
                            に記載のサイズやフォーマットで提出してください。
                          </p>
                          <p
                            v-for="(uploadError, index) in uploadErrors"
                            :key="index"
                            class="error-text">
                            {{ uploadError }}
                          </p>
                          <p
                            v-if="errors.image"
                            class="error-text">
                            {{ errors.image[0] }}
                          </p>
                          <input
                            ref="file"
                            type="file"
                            style="display:none"
                            @change="onFileChanged" />
                        </div>
                        <div
                          v-else
                          class="form-item">
                          <p>
                            ※ 楽曲審査完了後に申請できます
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="!isBtoC"
                        class="form-group">
                        <div class="form-label">
                          <label
                            v-tooltip="spTooltipConfig(tooltipMessages.spotifyCover)"
                            class="control-label">Spotify用 カバー写真
                          </label>
                          <i
                            v-tooltip="spTooltipConfig(tooltipMessages.spotifyCover)"
                            class="sp-tooltip-icon">
                          </i>
                        </div>
                        <div
                          v-if="isPhotoChangeable"
                          class="form-item">
                          <img
                            v-if="previewSpotifyImage"
                            style="max-width: 320px"
                            :src="previewSpotifyImage">
                          <a
                            v-tooltip="pcTooltipConfig(tooltipMessages.spotifyCover)"
                            class="c-btn c-btn--download--narrow"
                            :class=" { 'image-upload-btn' : previewSpotifyImage } "
                            href="#"
                            @click.prevent="onSpotifyUploadClicked">
                            {{ previewSpotifyImage ? '画像を変更する' : 'ファイルをアップロード' }}
                            <img
                              src="/img/common/icon-download_white.png"
                              alt="">
                          </a>

                          <p
                            v-for="(spotifyUploadError, index) in spotifyUploadErrors"
                            :key="index"
                            class="error-text">
                            {{ spotifyUploadError }}
                          </p>
                          <p
                            v-if="errors.spotify"
                            class="error-text">
                            {{ errors.spotify[0] }}
                          </p>
                          <input
                            ref="spotify"
                            type="file"
                            style="display:none"
                            @change="onFileChangedSpotifyCover" />
                        </div>
                        <div
                          v-else
                          class="form-item">
                          <p>
                            ※ 楽曲審査完了後に申請できます
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="!isBtoC"
                        class="form-group">
                        <div class="form-label">
                          <label
                            class="control-label"
                            for="publish_date">公開希望日
                          </label>
                        </div>
                        <div class="form-item">
                          <input
                            id="publish_date"
                            v-model="item.publish_date"
                            class="form-control form-control--w400"
                            type="text"
                            placeholder="2023-01-01"
                            :disabled="!isSelectAblePublishDate"
                            @blur="onFieldChanged('publish_date')">
                          <p
                            v-if="errors.publish_date"
                            class="error-text">
                            {{ errors.publish_date[0] }}
                          </p>
                          <p class="publish-date-description">
                            ※ 特に希望がない場合は未入力にしてください<br>
                            ※ 公開希望日は、配信ストア側の審査状況によりご指定頂いた日付より遅れる場合がございます。<br>
                            ※ アーティスト写真かSpotify用 カバー写真を更新する場合のみ公開希望日を入力可能です。<br>
                            ※ リクエスト受付後、順次対応させていただきます。
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-btn-wrap">
                  <a
                    href="#"
                    class="c-btn c-btn--back c-btn--back-left"
                    @click.prevent="onBackClicked">戻る
                    <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
                  </a>
                  <a
                    href="#"
                    class="c-btn"
                    @click.prevent="validate()">
                    内容を確認
                    <span class="c-btn__icon-arrow"></span>
                  </a>
                  <a
                    v-if="isNew"
                    href="#"
                    class="c-btn c-btn--back c-btn--right"
                    @click.prevent="onSkipClicked">あとで設定
                    <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import base64ToBinary from '../../../logic/image'
import ArtistConfirm from './Confirm'
import HeaderBar from '../HeaderBar'
import AlertView from '../AlertView'
import tooltip from '../../mixins/tooltip'
import tooltipMessages from './create-tooltips'

let vTimer = null
export default {
  name: 'ArtistCreate',
  components: {
    AlertView,
    HeaderBar,
    ArtistConfirm,
  },
  mixins: [
    tooltip,
  ],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    fromRelease: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
  },
  data() {
    return {
      item: {
        name_ja: '',
        name_kana: '',
        name_en: '',
        url: '',
        publish_date: '',
        blog: '',
        genre_ja: '',
        genre_en: '',
        area_ja: '',
        area_en: '',
        members: [
          {
            name_ja: '',
            role_ja: '',
            name_en: '',
            role_en: '',
          },
        ],
        profile_ja: '',
        profile_en: '',
        socials: {},
        is_narasu_displayed: 1,
      },
      genres: [],
      errors: [],
      showConfirmation: false,
      previewImage: null,
      previewSpotifyImage: null,
      validated: true,
      uploadErrors: [],
      spotifyUploadErrors: [],
      realtimeValidation: true,
      hasProducts: false,
      isPhotoChangeable: false,
      showWarningMsg: false,
      warningMsg: '山田 太郎（TARO YAMADA）など、翻訳表記を含めることはできません。',
    }
  },
  computed: {
    socials() {
      return {
        facebook: {
          type: '1', title: 'Facebook', note: '（URL）', placeholder: 'https://www.facebook.com/narasu.jp',
        },
        twitter: {
          type: '2', title: 'X', note: '（アカウント）', placeholder: '@narasu_jp',
        },
        youtube: {
          type: '3', title: 'YouTube', note: '（チャンネルURL）', placeholder: 'https://narasu.jp/',
        },
        instagram: {
          type: '4', title: 'Instagram', note: '（アカウント）', placeholder: 'narasu_jp',
        },
        soundcloud: {
          type: '5', title: 'SoundCloud', note: '（アカウント）', placeholder: 'narasu_jp',
        },
        tiktok: {
          type: '6', title: 'TikTok', note: '（アカウント）', placeholder: '@narasu_jp',
        },
      }
    },
    isSelectAblePublishDate() {
      return (this.previewImage && this.previewImage.indexOf('/') !== 0)
        || (this.previewSpotifyImage && this.previewSpotifyImage.indexOf('/') !== 0)
    },
  },
  mounted() {
    if (this.isNew) {
      this.$store.commit('hideSidebar')
    }
    if (this.isEdit) {
      this.fetchItem(this.$route.params.id)
      this.fetchProducts()
    }
    this.fetchGenres()
  },
  methods: {
    async fetchItem(id) {
      try {
        const response = await window.axios.get(`/api/client/artists/${id}`)
        this.item = response.data
        if (this.item.image_path) {
          this.previewImage = `/images/${this.item.image_path}`
        }
        if (this.item.spotify_image_path) {
          this.previewSpotifyImage = `/images/${this.item.spotify_image_path}`
        }
        const accordionKeys = [
          'profile_ja',
          'image_path',
          'spotify_image_path',
          'url',
          'blog',
          'socials',
        ]
        // 何か値が入っていればアコーディオンを開いておく
        for (let i = 0; i < accordionKeys.length; i += 1) {
          if (accordionKeys[i] === 'socials') {
            if (Object.keys(this.item.socials).some(key => !!this.item.socials[key])) {
              this.isOpen = true
              break
            }
          } else if (this.item[accordionKeys[i]]) {
            this.isOpen = true
            break
          }
        }
      } catch ({ response }) {
        if (response.status === 404) {
          this.$router.push({ name: 'index' })
        }
      }
    },
    async fetchGenres() {
      const response = await window.axios.get('/api/client/genres')
      this.genres = response.data
    },
    async fetchProducts() {
      const { data } = await window.axios.get('/api/client/products', {
        params: {
          artist_id: this.$route.params.id,
          status: [0, 1, 2],
        },
      })
      this.hasProducts = data.data.length > 0
      if (this.isBtoB) {
        // 配信待ち,配信中,更新中,更新納品中,追加ストア申請のみアー写の変更を許可
        const releasedStatus = [
          5, 6, 7, 17, 10,
        ]
        this.isPhotoChangeable = data.data.some(d => releasedStatus.includes(d.release_status))
      }
    },
    onAddMemberClicked() {
      this.item.members.push({
        name_ja: '',
        role_ja: '',
        name_en: '',
        role_en: '',
      })
    },
    onDeleteMemberClicked(index) {
      this.item.members.splice(index, 1)
    },
    onFieldChanged(key) {
      /* display warning message if the japanese and alphabet characters
      along with symbols are entered in japanese name input field */
      if (key === 'name_ja') {
        /* Hiragana: [\u3040-\u309F]
           Katakana: [\u30A0-\u30FF]
           Kanji: [\u4E00-\u9FAF]
         */
        const japaneseRegex = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/
        const alphabetRegex = /[A-Za-z]/
        const specialCharactersRegex = /[()（）\\[\]【】<>＜＞『』]/

        const containsJapanese = japaneseRegex.test(this.item.name_ja)
        const containsAlphabet = alphabetRegex.test(this.item.name_ja)
        const containsSpecialCharacters = specialCharactersRegex.test(this.item.name_ja)

        this.showWarningMsg = (containsJapanese && containsAlphabet) || containsSpecialCharacters
      }
      if (vTimer) {
        clearTimeout(vTimer)
      }
      vTimer = setTimeout(() => { this.validate(key) }, 500)
    },
    async validate(key) {
      try {
        const config = { headers: { 'content-type': 'multipart/form-data', 'X-CMAP-No-Loading': 1 } }
        const formData = this.compileFormData(false)
        if (this.isEdit) {
          formData.append('_method', 'put')
          await window.axios.post(`/api/client/artists/${this.$route.params.id}`, formData, config)
        } else {
          await window.axios.post('/api/client/artists', formData, config)
        }
      } catch ({ response }) {
        const { errors } = response.data
        if (key) {
          this.realtimeValidation = true
          this.$set(this.errors, key, errors[key])
        } else {
          this.realtimeValidation = false
          this.errors = errors
          window.scrollTo(0, 0)
          // 確認画面に遷移できるか
          this.showConfirmation = response.status === 422
            && Object.keys(errors).length === 1
            && Object.prototype.hasOwnProperty.call(errors, 'confirmed')
        }
      }
    },
    onReturnClicked() {
      window.scrollTo(0, 0)
      this.showConfirmation = false
    },
    compileFormData(confirmed) {
      const keys = [
        'name_ja',
        'name_kana',
        'name_en',
        'url',
        'blog',
        'genre_ja',
        'genre_en',
        'area_ja',
        'area_en',
        'members',
        'profile_ja',
        'profile_en',
        'socials',
        'confirmed',
        'is_narasu_displayed',
      ]
      const params = this.item
      params.confirmed = confirmed
      const formData = new FormData()

      if (this.previewImage && this.previewImage.indexOf('/') !== 0) {
        const base64String = this.previewImage.substr(this.previewImage.indexOf(',') + 1) // 先頭に制御文字があるので除去
        formData.append('image', base64ToBinary(base64String))
      }
      if (this.previewSpotifyImage && this.previewSpotifyImage.indexOf('/') !== 0) {
        const base64String = this.previewSpotifyImage.substr(this.previewSpotifyImage.indexOf(',') + 1) // 先頭に制御文字があるので除去
        formData.append('spotify', base64ToBinary(base64String))
      }
      if (this.isSelectAblePublishDate) {
        keys.push('publish_date')
      }
      Object.keys(params)
        .filter(key => (keys.indexOf(key) !== -1))
        .forEach(key => {
          if (key === 'members') {
            params[key].forEach((member, index) => {
              Object.keys(member).forEach(key2 => {
                formData.append(`members[${index}][${key2}]`, member[key2] !== null ? member[key2] : '')
              })
            })
          } else if (key === 'socials') {
            Object.keys(params.socials).forEach(index => {
              formData.append(`socials[${index}]`, params.socials[index] !== null ? params.socials[index] : '')
            })
          } else {
            formData.append(key, params[key] !== null ? params[key] : '')
          }
        })

      return formData
    },

    async onSaveClicked() {
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      const formData = this.compileFormData(true)
      if (this.isEdit) {
        formData.append('_method', 'put')
        await window.axios.post(`/api/client/artists/${this.$route.params.id}`, formData, config)
      } else {
        await window.axios.post('/api/client/artists', formData, config)
      }

      if (this.isNew) {
        window.location.href = '/client'
      } else if (this.type === 'release') {
        const release = JSON.parse(window.sessionStorage.getItem('album'))
        await this.$router.push({ name: `release-${release.type}-step1` })
      } else {
        await this.$router.push({ name: 'artist-index' })
      }
    },
    onSkipClicked() {
      window.location.href = '/client'
    },
    // ファイル選択ボタンクリック
    onUploadClicked() {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    // SpotifyCoverファイル選択ボタンクリック
    onSpotifyUploadClicked() {
      this.$refs.spotify.value = ''
      this.$refs.spotify.click()
    },
    // ファイル選択時コールバック
    onFileChanged(e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        if (this.isBtoC) this.checkImage(event.target.result)
        else this.checkImage(event.target.result, 'artistImage')
      }
      reader.readAsDataURL(files[0])
    },
    // Spotifyカバーファイル選択時コールバック
    onFileChangedSpotifyCover(e) {
      const files = e.target.files || e.dataTransfer.files
      const reader = new FileReader()
      reader.onload = event => {
        this.checkImage(event.target.result, 'spotifyCover')
      }
      reader.readAsDataURL(files[0])
    },

    // 画像のバリデーション
    async checkImage(base64image, type = 'artist') {
      this.error = ''
      this.uploadErrors = []
      this.spotifyUploadErrors = []
      this.validated = false
      const base64String = base64image.substr(base64image.indexOf(',') + 1) // 先頭に制御文字があるので除去
      const formData = new FormData()
      const config = { headers: { 'content-type': 'multipart/form-data' } }
      if (type === 'artist' || type === 'artistImage') {
        formData.append('image', base64ToBinary(base64String))
      } else {
        formData.append('spotifyImage', base64ToBinary(base64String))
      }
      const response = await window.axios.post(`/api/client/image/validate/${type}`, formData, config)
      if (response.data.result) {
        if (type === 'artist' || type === 'artistImage') this.previewImage = base64image
        else this.previewSpotifyImage = base64image
        this.validated = true
        delete this.errors.image
      } else {
        if (type === 'artist' || type === 'artistImage') this.uploadErrors = response.data.messages
        else this.spotifyUploadErrors = response.data.messages
        this.validated = false
      }
    },
    onBackClicked() {
      this.$router.go(-1)
    },
    accordionToggle() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style scoped>
.form-group-wrap__btn-wrap {
  height: 49px;
}
.form-group {
  position: relative;
}
.publish-date-description {
  font-size: 0.8em;
}
.c-indent-list__desc {
  font-weight: normal;
  line-height: 1.7;
  display: inline-block;
  font-size: 1.4rem;
  margin-left: -4.5em;
}
.c-indent-p__desc {
  margin-left: -9.5em;
}
.image-upload-btn{
  top: 40%;
}
@media screen and (max-width: 895px) {
  .c-indent-list__desc {
    padding-left: 5.2em;
    font-size: 2.9333333333vw;
    text-align: left;
  }
  .c-indent-p__desc {
    padding-left: 9.4em
  }
}
@media screen and (min-width: 896px) {
  .delete-area {
    display: inline;
  }
  .c-btn--delete {
    position: absolute;
    bottom: calc(50% - 25px);
    margin-left: 3vmin;
  }
}
@media screen and (max-width: 896px) {
  .delete-area {
    text-align: center;
    display: block;
  }
  .c-btn--delete {
    margin: 3vmin auto 0px auto;
  }
}
</style>
